import supercluster from 'points-cluster';
import isEmpty from 'lodash/isEmpty';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import { formatDate } from './date';

export const formatRun = (run, showRunSequence = true) => {
    if (run) {
        if (!isEmpty(run.runSequence) && showRunSequence) {
            return `${run.routeCode} - ${formatDate(run.runDate)} - ${run.runSequence}`;
        }
        return `${run.runDate} - ${run.routeCode}`;
    }
    return '';
};

export const formatEmc = (emc, showDockCode = true) => {
    if (emc.emcCode && emc.emcPlantCode && emc.emcDockCode && showDockCode) {
        return `${emc.emcCode} - ${emc.emcPlantCode} - ${emc.emcDockCode}`;
    } else if (emc.emcCode && emc.emcPlantCode) {
        return `${emc.emcCode} - ${emc.emcPlantCode}`;
    } else if (emc.emcCode) {
        return `${emc.emcCode}`;
    }
    return '';
};

export const formatSupplier = (supplier, showDockCode = true) => {
    if (
        supplier.supplierCode &&
        supplier.supplierPlantCode &&
        supplier.supplierDockCode &&
        showDockCode
    ) {
        return `${supplier.supplierCode} - ${supplier.supplierPlantCode} - ${
            supplier.supplierDockCode
        }`;
    } else if (supplier.supplierCode && supplier.supplierPlantCode) {
        return `${supplier.supplierCode} - ${supplier.supplierPlantCode}`;
    } else if (supplier.supplierCode) {
        return `${supplier.supplierCode}`;
    }
    return '';
};

export const formatStopLocation = (stop, showDockCode = true) => {
    if (stop) {
        if (!isEmpty(stop.stopDockCode) && showDockCode) {
            return `${stop.stopNumber} - ${stop.stopCode} - ${stop.stopPlantCode} - ${
                stop.stopDockCode
            }`;
        }
        return `${stop.stopNumber} - ${stop.stopCode} - ${stop.stopPlantCode}`;
    }
    return '';
};

export const calculateBoundsForStops = stops => {
    const defaultBounds = {
        nw: {
            lat: 52.061474,
            lng: 1.139915,
        },
        se: {
            lat: 49.263,
            lng: 7.023094,
        },
    };
    const nStop = maxBy(stops, 'latLng.lat');
    const eStop = maxBy(stops, 'latLng.lng');
    const sStop = minBy(stops, 'latLng.lat');
    const wStop = minBy(stops, 'latLng.lng');

    if (nStop && eStop && sStop && wStop) {
        return {
            nw: {
                lat: nStop.latLng.lat,
                lng: wStop.latLng.lng,
            },
            se: {
                lat: sStop.latLng.lat,
                lng: eStop.latLng.lng,
            },
        };
    }

    return defaultBounds;
};

export const createGPSClusters = (gpsLocations, bounds) => {
    const flattenedLocations = gpsLocations.map(loc => {
        loc.lat = loc.latitude;
        loc.lng = loc.longitude;
        return loc;
    });
    const clusters = supercluster(flattenedLocations, {
        minZoom: 0,
        maxZoom: 18,
        radius: 0,
    });
    // Fix outdated points-cluster lib: expects property called bounds, not newBounds
    bounds.bounds = bounds.newBounds;
    return clusters(bounds);
};
export const createStopClusters = (stops, bounds) => {
    const flattenedStops = stops.map(s => {
        s.lat = s.latLng ? s.latLng.lat : 0;
        s.lng = s.latLng ? s.latLng.lng : 0;
        return s;
    });
    const clusters = supercluster(flattenedStops, {
        minZoom: 0,
        maxZoom: 18,
        radius: 0,
    });
    // Bypass for outdated points-cluster lib: expects property called bounds, not newBounds
    bounds.bounds = bounds.newBounds;
    return clusters(bounds);
};
